module.exports = __webpack_public_path__ + "img/logo-rodi.133500fc.png";